import { gql } from '@apollo/client';

export const GET_WORKPACKAGES = gql`
  query workPackages($filter: WorkPackageFilterInput, $paging: PagingInput) {
    workPackages(input: $filter, paging: $paging) {
      cursor
      total
      items {
        id
        tag
        startDate
        endDate
        numBlocks
        materialsOnSite {
          commodityType {
            id
            name
          }
          materialTracking
          totalCommodities
        }
        earnedHours
        totalEarnableHours
        percentageComplete
      }
    }
  }
`;

export const GET_WORKPACKAGE_STATS_BY_IDS = gql`
  query workPackagesByIds($ids: [ID!]!) {
    workPackagesByIds(ids: $ids) {
      id
      tag
      numBlocks
      materialsOnSite {
        commodityType {
          id
          name
        }
        materialTracking
        totalCommodities
      }
      earnedHours
      totalEarnableHours
    }
  }
`;

export const GET_WORKPACKAGE_DETAIL_BY_IDS = gql`
  query workPackagesByIds($ids: [ID!]!) {
    workPackagesByIds(ids: $ids) {
      id
      tag
      numBlocks
      availableCommodityTypes {
        id
        name
      }
      lastUpdated
      startDate
      endDate
      plannedMilestoneStartDate
      plannedMilestoneEndDate
      earnedHours
      plannedHours
      totalEarnableHours
      percentageComplete
      materialsOnSite {
        materialTracking
        totalCommodities
        commodityType {
          id
          name
        }
      }
      facilities {
        id
      }
      primaryOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
      secondaryOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
      otherOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
    }
  }
`;

export const GET_WORKPACKAGE_ADDITIONAL_INFO_BY_IDS = gql`
  query workPackagesByIds($ids: [ID!]!) {
    workPackagesByIds(ids: $ids) {
      id
      tag
      numBlocks
      availableCommodityTypes {
        id
        name
      }
      lastUpdated
      startDate
      endDate
      plannedMilestoneStartDate
      plannedMilestoneEndDate
      earnedHours
      plannedHours
      totalEarnableHours
      percentageComplete
      materialsOnSite {
        materialTracking
        totalCommodities
        commodityType {
          id
          name
        }
      }
      facilities {
        id
      }
      primaryOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
      secondaryOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
      otherOwners {
        persona
        crewMember {
          id
          firstName
          lastName
          imageUrl
          shiftType
        }
      }
    }
  }
`;

export const GET_WORKPACKAGE_DOCUMENTS_BY_IDS = gql`
  query workPackagesByIds($ids: [ID!]!) {
    workPackagesByIds(ids: $ids) {
      id
      tag
      allDocuments {
        documentNumber
        url
        commodity {
          weld {
            id
            tag
          }
          materialCommodity {
            id
            tag
          }
        }
      }
      attachments {
        id
        fileName
        url
        attachmentType
        fileSize
        createdAt
        creator {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const UPDATE_WORK_PACKAGE_SCHEDULE = gql`
  mutation updateWorkPackageSchedule($input: UpdateWorkPackageScheduleInput!) {
    updateWorkPackageSchedule(input: $input) {
      workPackages {
        id
        startDate
        endDate
        plannedMilestoneStartDate
        plannedMilestoneEndDate
      }
      unplannedMilestones {
        id
        name
        isExpired
        hours
        plannedStartDate
        plannedEndDate
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
            imageUrl
          }
        }
        quantity {
          quantity
          unitOfMeasure
        }
        commodity {
          materialCommodity {
            id
            tag
            workPackage {
              id
              tag
              plannedHours
              plannedMilestoneStartDate
              plannedMilestoneEndDate
            }
            type {
              id
              name
            }
            material {
              mwrs {
                mwrNumber
                mwrDate
                mwrStatus
              }
              mrrNumber
              mrrDate
              deliveryDate
            }
          }
          weld {
            id
            tag
            workPackage {
              id
              tag
              plannedHours
              plannedMilestoneStartDate
              plannedMilestoneEndDate
            }
            type {
              id
              name
            }
          }
        }
      }
      erroredWorkPackages {
        errorCode
        workPackageId
      }
    }
  }
`;

export const SUBSCRIPTION_WORKPACKAGE_UPDATED = gql`
  subscription onWorkPackagesUpdated {
    workPackagesUpdated {
      workPackageIds
      affectedOwnerIds
    }
  }
`;

export const UPDATE_WORKPACKAGE_DISCIPLINES = gql`
  mutation updateWorkPackageDisciplines($input: [UpdateWorkPackageDisciplineInput]!) {
    updateWorkPackageDisciplines(input: $input) {
      disciplines {
        id
        isActive
      }
      error
    }
  }
`;
export const GET_WORKPACKAGE_MILESTONE_STATS = gql`
  query workPackagesByIds($ids: [ID!]!, $input: MilestonesActivityStatsFilterInput!) {
    workPackagesByIds(ids: $ids) {
      id
      tag
      milestoneActivityStats(input: $input) {
        commodityType {
          id
          name
        }
        milestoneActivityStats {
          milestoneActivityStatus
          stats {
            milestoneType {
              id
              name
            }
            numMilestones
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION_WORK_PACKAGES_IMPORT = gql`
  subscription workPackagesImport {
    workPackagesImport {
      importStatus
    }
  }
`;

export const DELETE_WORK_PACKAGE_ATTACHMENT = gql`
  mutation deleteWorkPackageAttachment($input: DeleteWorkPackageAttachmentInput!) {
    deleteWorkPackageAttachment(input: $input) {
      error
      workPackage {
        id
        attachments {
          id
        }
      }
    }
  }
`;
